import { Store } from 'vuex';

var KEY = '__decorators__';
function createDecorator(handler) {
    return function () { return function (target, propertyName) {
        var decorators = getDecorators(target);
        decorators.set(propertyName, handler);
    }; };
}
function getDecorators(target) {
    var ctor = typeof target === 'function' ? target : target.constructor;
    var proto = ctor.prototype;
    var decorators = proto[KEY];
    if (!proto.hasOwnProperty(KEY) && decorators) {
        proto[KEY] = new Map(decorators.entries());
        return proto[KEY];
    }
    else if (!decorators) {
        proto[KEY] = new Map();
        return proto[KEY];
    }
    return decorators;
}

function getState(pState, pNamespace) {
    var state = pState;
    for (var _i = 0, pNamespace_1 = pNamespace; _i < pNamespace_1.length; _i++) {
        var namespace = pNamespace_1[_i];
        state = state[namespace];
    }
    return state;
}
function bindState(pBuilder, pModule, propertyName) {
    var value = pModule[propertyName];
    var provider = pBuilder.provider;
    var options = pBuilder.options;
    Object.defineProperty(pModule, propertyName, {
        get: function () {
            var state = provider.store
                ? getState(provider.store.state, pBuilder.namespaces)
                : options.state;
            return state[propertyName];
        },
        set: function (val) {
            var state = provider.store
                ? getState(provider.store.state, pBuilder.namespaces)
                : options.state;
            state[propertyName] = val;
        }
    });
    pModule[propertyName] = value;
}
var State = createDecorator(bindState);

function alreadyExistsError(namespace) {
    return {
        code: 'already_exists',
        message: "Could not add module \"" + namespace + "\": trying to add a module that already exists",
        params: {
            namespace: namespace
        }
    };
}
function removeStaticError(namespace) {
    return {
        code: 'remove_static',
        message: "Could not remove module \"" + namespace + "\": trying to remove a static module",
        params: {
            namespace: namespace
        }
    };
}
function getterNotFoundError(propertyName, className) {
    return {
        code: 'getter_not_found',
        message: "Could not find getter \"" + propertyName + "\" for module " + className,
        params: {
            className: className,
            propertyName: propertyName
        }
    };
}

function getGetter(pModule, propertyName) {
    var getter = pModule.__lookupGetter__(propertyName);
    if (!getter) {
        var className = pModule.constructor.name;
        throw getterNotFoundError(propertyName, className);
    }
    var boundGetter = getter.bind(pModule);
    return function (state) { return boundGetter(); };
}
function bindGetter(pBuilder, pModule, propertyName) {
    var options = pBuilder.options;
    var provider = pBuilder.provider;
    options.getters[propertyName] = getGetter(pModule, propertyName);
    var nsPath = pBuilder.namespaces.join('/');
    var getterName = (nsPath ? nsPath + '/' : '') + propertyName;
    Object.defineProperty(pModule, propertyName, {
        get: function () {
            return provider.store.getters[getterName];
        }
    });
}
var Getter = createDecorator(bindGetter);

function getMutation(pModule, propertyName) {
    var mutation = pModule[propertyName];
    var boundMutation = mutation.bind(pModule);
    return function (state, payload) { return boundMutation(payload); };
}
function bindMutation(pBuilder, pModule, propertyName) {
    var options = pBuilder.options;
    var provider = pBuilder.provider;
    options.mutations[propertyName] = getMutation(pModule, propertyName);
    var nsPath = pBuilder.namespaces.join('/');
    var mutationName = (nsPath ? nsPath + '/' : '') + propertyName;
    pModule[propertyName] = function (payload) {
        provider.store.commit(mutationName, payload);
    };
}
var Mutation = createDecorator(bindMutation);

function getAction(pModule, propertyName) {
    var action = pModule[propertyName];
    var boundAction = action.bind(pModule);
    return function (state, payload) { return boundAction(payload); };
}
function bindAction(pBuilder, pModule, propertyName) {
    var options = pBuilder.options;
    var provider = pBuilder.provider;
    options.actions[propertyName] = getAction(pModule, propertyName);
    var nsPath = pBuilder.namespaces.join('/');
    var actionName = (nsPath ? nsPath + '/' : '') + propertyName;
    pModule[propertyName] = function (payload) {
        return provider.store.dispatch(actionName, payload);
    };
}
var Action = createDecorator(bindAction);

function transformRecursive(pStoreProvider, pModule, pNamespace, dynamic) {
    if (pNamespace === void 0) { pNamespace = []; }
    if (dynamic === void 0) { dynamic = false; }
    var joinedNamespace = pNamespace.join('/');
    if (pStoreProvider.modules.has(joinedNamespace)) {
        throw alreadyExistsError(joinedNamespace);
    }
    pStoreProvider.modules.set(joinedNamespace, {
        dynamic: dynamic,
        module: pModule
    });
    var storeOptions = {
        actions: {},
        getters: {},
        modules: {},
        mutations: {},
        namespaced: true,
        state: {}
    };
    var builder = {
        dynamic: dynamic,
        namespaces: pNamespace,
        options: storeOptions,
        provider: pStoreProvider
    };
    var constructor = pModule.constructor;
    var decorators = getDecorators(constructor);
    decorators.forEach(function (decorator, propertyName) { return decorator(builder, pModule, propertyName); });
    return storeOptions;
}

function bindModule(pBuilder, pModule, propertyName) {
    var subModule = pModule[propertyName];
    if (!subModule) {
        return;
    }
    try {
        var moduleOptions = transformRecursive(pBuilder.provider, subModule, pBuilder.namespaces.concat(propertyName), pBuilder.dynamic);
        var options = pBuilder.options;
        options.modules[propertyName] = moduleOptions;
    }
    catch (err) {
        console.error(err);
    }
    Object.defineProperty(pModule, propertyName, {
        get: function () {
            return subModule;
        }
    });
}
var Module = createDecorator(bindModule);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function createVuexStore(pModule, pOptions) {
    var storeProvider = {
        modules: new Map()
    };
    var userOptions = __assign({ modules: {}, plugins: [], strict: false }, pOptions);
    var options = transformRecursive(storeProvider, pModule);
    options.strict = userOptions.strict;
    options.modules = __assign(__assign({}, options.modules), userOptions.modules);
    options.plugins = userOptions.plugins;
    var store = new Store(options);
    store.__vxs_root__ = pModule;
    store.__vxs_modules__ = storeProvider.modules;
    storeProvider.store = store;
    return store;
}
function registerModule(store, namespace, instance, options) {
    var typedStore = store;
    if (!typedStore.__vxs_modules__) {
        typedStore.__vxs_modules__ = new Map();
    }
    var storeProvider = {
        modules: typedStore.__vxs_modules__
    };
    var vuexModule = transformRecursive(storeProvider, instance, namespace, true);
    store.registerModule(namespace, vuexModule, options);
    storeProvider.store = store;
}
function unregisterModule(store, namespace) {
    var joinedNamespace = namespace.join('/');
    var typedStore = store;
    if (!typedStore.__vxs_modules__) {
        typedStore.__vxs_modules__ = new Map();
    }
    var moduleProvider = typedStore.__vxs_modules__.get(joinedNamespace);
    var isDynamic = moduleProvider ? moduleProvider.dynamic : true;
    if (!isDynamic) {
        throw removeStaticError(joinedNamespace);
    }
    // Remove module
    typedStore.__vxs_modules__.delete(joinedNamespace);
    // Remove submodules
    var submodulesNamespace = joinedNamespace + '/';
    var keys = Array.from(typedStore.__vxs_modules__.keys());
    keys
        .filter(function (key) { return key.startsWith(submodulesNamespace); })
        .forEach(function (key) { return typedStore.__vxs_modules__.delete(key); });
    // Unregister module from vuex store
    store.unregisterModule(namespace);
}
function useStore(vuexStore) {
    var typedStore = vuexStore;
    return typedStore.__vxs_root__;
}
function useModule(vuexStore, namespace) {
    if (namespace === void 0) { namespace = []; }
    var joinedNamespace = namespace.join('/');
    var typedStore = vuexStore;
    if (!typedStore.__vxs_modules__) {
        typedStore.__vxs_modules__ = new Map();
    }
    var moduleProvider = typedStore.__vxs_modules__.get(joinedNamespace);
    return moduleProvider ? moduleProvider.module : undefined;
}

export { State, Getter, Mutation, Action, Module, createVuexStore, registerModule, unregisterModule, useStore, useModule };
